import { useRef, useState } from 'react';
import { ArrowUpRight, Check, House, Snowflake, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Reveal } from './Shared';
import { SERVICE_GROUPS } from './data';
import { ServicesVideo } from './ServicesVideo';
import { ServicesIntro } from './ServicesIntro';
import './Services.css';

const ICONS = [Sparkles, House, Snowflake];

export const Services = ({ selected, toggleService, onChooseGroup }) => {
  const [active, setActive] = useState('reinigung');
  const [open, setOpen] = useState(false);
  const moveToForm = useRef(false);
  const group = SERVICE_GROUPS.find(g => g.id === active);
  const continueToForm = () => {
    onChooseGroup(active);
    moveToForm.current = true;
    setOpen(false);
  };
  const afterClose = event => {
    if (!moveToForm.current) return;
    event.preventDefault();
    moveToForm.current = false;
    document.getElementById('kontakt')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    document.getElementById('inquiry-name')?.focus({ preventScroll: true });
  };
  return <section className="services-section section-space" id="leistungen" data-testid="services-section">
    <ServicesIntro />
    <div className="services-layout" data-testid="services-layout">
    <div className="services-content services-cards-container">
    <div className="services-grid services-overview" data-testid="service-cards-stack">
      {SERVICE_GROUPS.map((item, index) => { const Icon = ICONS[index]; return <Reveal key={item.id} delay={index * 0.1} className={`service-card service-${item.id}`} id={item.id} data-testid={`service-card-${item.id}`}>
        <div className="service-card-content"><div className="service-topline"><Icon size={20} strokeWidth={1.5} /><span>{item.number} /</span></div>
          <h3 data-testid={`service-title-${item.id}`}>{item.title}</h3>
          <p className="service-description" data-testid={`service-description-${item.id}`}>{item.description}</p>
          <ul className="service-preview" data-testid={`service-preview-${item.id}`}>{item.items.slice(0, index === 0 ? 3 : 2).map((service, i) => <li key={service} data-testid={`service-preview-${item.id}-${i}`}><Check size={13} />{service}</li>)}</ul>
          {index === 1 && <span className="service-footnote" data-testid="maintenance-scope">Leichte Tätigkeiten, keine zulassungspflichtigen Handwerksarbeiten.</span>}
          <Button variant="ghost" className="service-more" onClick={() => { setActive(item.id); setOpen(true); }} data-testid={`service-details-${item.id}`}>{index === 2 ? 'Winterdienst entdecken' : `Alle ${item.items.length} Leistungen entdecken`}<span><ArrowUpRight size={20} /></span></Button>
        </div>
      </Reveal>; })}
    </div>
    </div>
    <ServicesVideo />
    </div>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="service-dialog" data-testid="service-detail-dialog" data-lenis-prevent onCloseAutoFocus={afterClose}>
        <span className="dialog-kicker" data-testid="service-dialog-kicker">GUT BETREUT. BIS INS DETAIL.</span>
        <DialogTitle data-testid="service-dialog-title">{group?.title}</DialogTitle>
        <DialogDescription data-testid="service-dialog-description">{group?.description} Wählen Sie die Leistungen, die Sie interessieren.</DialogDescription>
        <div className="dialog-service-list">{group?.items.map((service, i) => <label key={service} className={`dialog-service-option ${selected.includes(service) ? 'selected' : ''}`} data-testid={`dialog-service-label-${i}`}><input type="checkbox" checked={selected.includes(service)} onChange={() => toggleService(service)} data-testid={`dialog-service-checkbox-${i}`} /><span>{service}</span><Check size={16} /></label>)}</div>
        {group?.id === 'hausmeister' && <p className="dialog-note" data-testid="service-dialog-scope">Unser Hausmeisterservice umfasst ausschließlich leichte Tätigkeiten, keine zulassungspflichtigen Handwerksarbeiten.</p>}
        <Button className="action-link dialog-cta" data-testid="service-dialog-inquiry-button" onClick={continueToForm}>Unverbindliches Angebot anfragen<ArrowUpRight size={18} /></Button>
      </DialogContent>
    </Dialog>
  </section>;
};